// Mock data for ARK Scaffolding website

export const products = [
  {
    id: 1,
    name: "Vertical",
    description: "High-strength vertical standards used as the main load-bearing members in scaffolding structures. Designed for stability and durability on construction sites.",
    detailedDescription: "Vertical standards are the backbone of any scaffolding system, providing primary vertical load-bearing support. Made from high-grade steel with anti-corrosion coating, these standards feature precision-welded cups at regular intervals for secure ledger connections. Available in multiple heights (1m, 1.5m, 2m, 2.5m, 3m) to suit various project requirements. Our verticals meet international safety standards and are designed for repeated use without compromising structural integrity.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/07p4msbn_D8681F39-C4DB-40FE-8A45-A4519EC20B4D.png",
    specifications: ["Available heights: 1m to 3m", "Material: High-grade steel", "Load capacity: Up to 2000 kg", "Corrosion-resistant coating"]
  },
  {
    id: 2,
    name: "Ledger",
    description: "Horizontal connecting members that link verticals and distribute loads evenly, ensuring structural balance and safety.",
    detailedDescription: "Ledgers form the horizontal framework of scaffolding systems, connecting vertical standards and providing crucial load distribution. Manufactured from heavy-duty steel tubes with reinforced blade connections, these components ensure even weight distribution across the structure. The precision-engineered blades lock securely into vertical cups, creating a rigid and stable framework. Available in standard lengths (2.5m, 2m, 1.5m, 1.2m, 1m, 0.5m) for flexible configuration.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/jvyvbj9d_3867DEC3-77C8-461B-8DF9-06C0E9C32921.png",
    specifications: ["Standard lengths: 0.5m to 2.5m", "Quick-lock blade system", "Heavy-duty steel construction", "Load tested and certified"]
  },
  {
    id: 3,
    name: "U Jack",
    description: "Adjustable top jack used to support beams and slab formwork. Provides accurate height adjustment for proper leveling.",
    detailedDescription: "U Jacks are essential adjustable support components designed for precise height control in formwork applications. Featuring a robust threaded mechanism with a U-shaped top plate, these jacks provide reliable support for beams and slab formwork. The threaded rod allows for fine height adjustments, ensuring perfect leveling. Built with high-tensile steel and featuring smooth rotation for easy adjustment, U Jacks are indispensable for concrete work and temporary support structures.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/mx9ea9f9_D97662AE-13FD-475B-8500-F90ED30BAB3A.png",
    specifications: ["Adjustable height range", "U-shaped top plate", "Smooth threaded adjustment", "High load-bearing capacity"]
  },
  {
    id: 4,
    name: "Base Jack",
    description: "Installed at the bottom of scaffolding systems to allow height adjustment and firm ground support on uneven surfaces.",
    detailedDescription: "Base Jacks are critical foundation components that provide stable support and height adjustment at ground level. The robust base plate distributes loads evenly across the ground surface, while the threaded spindle allows for precise leveling on uneven terrain. Constructed from heavy-gauge steel with reinforced base plates, these jacks prevent settlement and maintain scaffolding stability. Essential for ensuring the entire structure remains level and secure throughout the project duration.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/ik81esbv_2815436E-F473-4401-85FE-948C3EB8B294.png",
    specifications: ["Wide base plate for stability", "Threaded height adjustment", "Multiple hole base plate", "Anti-slip surface"]
  },
  {
    id: 5,
    name: "Props",
    description: "Telescopic adjustable steel props used for temporary slab and beam support. Easy to adjust and capable of carrying heavy loads.",
    detailedDescription: "Adjustable steel props are versatile telescopic support systems designed for temporary load-bearing applications. These props feature an inner and outer tube design with a threaded collar for height adjustment, providing reliable support for slabs, beams, and formwork during construction. The pin-and-collar mechanism ensures secure locking at the desired height. Available in various sizes (2x2m, 2x2.5m, 2x3m, 3x3m), our props are manufactured from high-strength steel and tested to meet rigorous safety standards.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/xkaihke5_89D69437-AECC-45ED-91CB-F9DA878086C1.png",
    specifications: ["Telescopic design", "Multiple size options", "Pin-lock mechanism", "Heavy-duty construction"]
  },
  {
    id: 6,
    name: "C Channel",
    description: "Heavy-duty C-shaped steel sections used for framing, structural support, and scaffolding applications.",
    detailedDescription: "C Channel sections are structural steel components with a distinctive C-shaped profile, offering excellent strength-to-weight ratio for various construction applications. These channels are ideal for creating support frames, bridging spans, and reinforcing scaffolding structures. Manufactured from hot-rolled steel, C Channels provide superior load-bearing capacity and resistance to bending forces. Available in standard 3m and 6m lengths, they can be easily cut to custom sizes for specific project requirements.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/czhu2yee_A7BDBFB5-BA5D-4327-8342-E6B75FB901C5.png",
    specifications: ["C-shaped profile", "Hot-rolled steel", "Available: 3m and 6m lengths", "High strength-to-weight ratio"]
  },
  {
    id: 7,
    name: "Square Tube",
    description: "Strong square hollow steel sections used in frames and scaffolding structures due to their rigidity and clean finish.",
    detailedDescription: "Square Tube sections are hollow structural steel members with uniform square cross-sections, providing excellent rigidity and clean aesthetic appeal. These tubes are perfect for frame construction, handrails, and structural support applications where clean lines and strong connections are required. The square profile allows for easy bolting and welding at right angles, making assembly straightforward. Our square tubes are manufactured to precise dimensions and are available in 3m and 6m standard lengths.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/36qvqct6_D82FE771-0918-4153-B9EA-8D2BDE12E441.png",
    specifications: ["Square hollow section", "Uniform cross-section", "Standard lengths: 3m, 6m", "Easy connection points"]
  },
  {
    id: 8,
    name: "Round Pipe",
    description: "ISI-grade round steel pipes commonly used in scaffolding, railing, and temporary construction frameworks.",
    detailedDescription: "Round Pipes are ISI-certified hollow steel tubes essential for scaffolding verticals, ledgers, and temporary structural frameworks. These pipes feature consistent wall thickness and smooth surface finish, ensuring reliable connections and long service life. The round profile provides uniform strength in all directions and is ideal for load-bearing applications. Our pipes undergo rigorous quality testing to meet ISI standards for construction use, available in 3m and 6m standard lengths.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/uyjqjp5u_92EDACFA-D514-441E-8065-0524E0C67144.png",
    specifications: ["ISI certified", "Uniform wall thickness", "Smooth surface finish", "Multi-directional strength"]
  },
  {
    id: 9,
    name: "Span",
    description: "Horizontal bridging components used between scaffolding frames to support platforms and enhance overall structural stability.",
    detailedDescription: "Span components are critical bridging elements that connect scaffolding frames and provide essential support for working platforms. Featuring lattice truss or beam construction, spans distribute loads efficiently across multiple support points. These components are engineered to handle concentrated loads while maintaining structural rigidity. Available in various lengths and load capacities, our spans are designed for both residential and heavy industrial applications, ensuring worker safety at height.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/qte7jr1z_25D31047-BCA2-4993-8822-C831980B6AD3.png",
    specifications: ["Lattice truss design", "Multiple length options", "High load capacity", "Reinforced construction"]
  },
  {
    id: 10,
    name: "Platform",
    description: "Anti-slip steel working platforms designed for safe movement and load-bearing at height.",
    detailedDescription: "Working Platforms are engineered decking systems providing safe, stable working surfaces at elevated heights. Featuring anti-slip perforated steel or plank construction, these platforms ensure secure footing in all weather conditions. The modular design allows for easy installation and removal, while reinforced edges prevent material spillage. Our platforms meet stringent safety regulations and are load-tested to support workers, tools, and materials simultaneously. Available in standard widths with various length options.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/m4ejp6bt_F6A7F119-6D32-47E2-8FBF-96EEC5285AE5.png",
    specifications: ["Anti-slip surface", "Modular design", "Load-tested certification", "Multiple size options"]
  },
  {
    id: 11,
    name: "H Frame",
    description: "Prefabricated H-shaped frames used for fast scaffolding structures, suitable for residential and commercial projects.",
    detailedDescription: "H Frame scaffolding systems are pre-welded frame units designed for rapid assembly and deployment. The distinctive H-shape provides inherent strength and stability, making these frames ideal for quick project setup. Featuring built-in ladder rungs for easy climbing and multiple connection points for bracing and platforms, H Frames are versatile solutions for facades, interiors, and access scaffolding. Available in standard heights (6ft, 8ft), these frames significantly reduce installation time while maintaining structural integrity.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/01x86oym_800CB7CB-66FF-45A2-9B8A-899053A3BCFE.png",
    specifications: ["Pre-welded construction", "Integrated ladder rungs", "Available: 6ft and 8ft", "Quick assembly design"]
  },
  {
    id: 12,
    name: "C Bracing",
    description: "Diagonal bracing components used to strengthen scaffolding structures and improve lateral stability.",
    detailedDescription: "C Bracing (Cross Bracing) components are diagonal steel members that provide essential lateral stability to scaffolding structures. These braces prevent swaying and distribute lateral forces throughout the scaffold frame, crucial for wind resistance and overall structural integrity. The flattened ends feature multiple fixing holes for secure attachment to verticals or frames. Available in various lengths to accommodate different bay sizes, C Bracing is mandatory for safe scaffold construction according to safety regulations.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/lmoy95ru_B0A7F39E-0B15-44C6-979C-DDE47B5F21C8.jpeg",
    specifications: ["Diagonal reinforcement", "Wind resistance", "Multiple hole fixing", "Safety regulation compliant"]
  },
  {
    id: 13,
    name: "Joint Pin",
    description: "Steel connecting pins used to join vertical standards securely and maintain proper alignment of scaffolding structures.",
    detailedDescription: "Joint Pins are precision-machined steel connectors used to extend vertical standards and maintain perfect alignment in multi-level scaffolding. These pins feature a spigot design that inserts into the hollow section of verticals, providing a strong mechanical connection. The external collar or wedge mechanism ensures the joint remains secure under load. Essential for creating scaffolding structures exceeding single-piece vertical heights, joint pins maintain structural continuity and load transfer efficiency.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/p97q810k_B852C86F-13CD-422E-92D7-64099B2F5EED.png",
    specifications: ["Spigot connection design", "Secure locking mechanism", "Maintains alignment", "High-strength steel"]
  },
  {
    id: 14,
    name: "Coupler",
    description: "Versatile connecting clamps used to join scaffolding tubes at various angles, providing flexible configuration options.",
    detailedDescription: "Couplers (Clamps) are essential fastening devices that connect scaffolding tubes and pipes at right angles, parallel, or swivel positions. These forged steel components feature dual-bolt tightening mechanisms for secure, high-strength connections. Available in types including right-angle couplers, swivel couplers, and sleeve couplers, they provide ultimate flexibility in scaffolding configuration. Each coupler is drop-forged for maximum strength and undergoes load testing to ensure safe working limits. Ideal for complex structures requiring non-standard connections.",
    image: "https://customer-assets.emergentagent.com/job_construction-hire/artifacts/vfyhahy7_17B4C330-1D61-4BED-9315-420708309550.png",
    specifications: ["Drop-forged steel", "Multiple connection types", "Dual-bolt mechanism", "Load-tested certification"]
  }
];

export const heroSlides = [
  {
    id: 1,
    title: "Scaffolding on Rent in Pune, Mumbai & Across Maharashtra",
    subtitle: "Safe. Strong. Site-Ready.",
    cta: "Call / WhatsApp: 9766601155",
    image: "https://images.unsplash.com/photo-1640631005057-de521cfcd36e"
  },
  {
    id: 2,
    title: "Strong Support for Every Project",
    subtitle: "High-quality scaffolding material on hire",
    cta: "9766601155",
    image: "https://images.unsplash.com/photo-1765706845871-951abd038627"
  },
  {
    id: 3,
    title: "Trusted Scaffolding Hire Solutions",
    subtitle: "Quality material. Reliable supply.",
    cta: "9766601155",
    image: "https://images.unsplash.com/photo-1653587193506-7719d772d901"
  }
];

export const cupLockComponents = [
  "Vertical Standards with cups",
  "Ledgers",
  "Bracings",
  "Base Jacks",
  "U Jacks"
];

export const cupLockAdvantages = [
  "Fast locking system",
  "High load-bearing capacity",
  "Suitable for complex structures",
  "Minimal loose components",
  "Strong and durable"
];

export const whyChooseUs = [
  {
    title: "Quality & Serviced Material",
    description: "High-strength, well-maintained scaffolding equipment that meets safety standards and is thoroughly inspected before every deployment."
  },
  {
    title: "Professional & Experienced Team",
    description: "Our expert team provides reliable support and consultation to ensure your project runs smoothly and safely."
  },
  {
    title: "Competitive Pricing",
    description: "Cost-effective rental solutions that help you manage your budget without compromising on quality or safety."
  },
  {
    title: "Timely Delivery & Pickup",
    description: "Reliable delivery and pickup services to keep your project on schedule without any delays."
  },
  {
    title: "High Level of Safety",
    description: "All equipment is compliant with industry safety standards, ensuring secure and reliable structures at every height."
  },
  {
    title: "Wide Product Range",
    description: "Comprehensive selection from traditional props to advanced Cuplock systems, meeting diverse project requirements."
  }
];

export const whyRentVsBuy = [
  {
    title: "No Large Upfront Investment",
    description: "Eliminate massive capital expenditure on scaffolding equipment. Rent only what you need, when you need it.",
    icon: "💰"
  },
  {
    title: "Zero Maintenance Hassles",
    description: "We handle all maintenance, repairs, and servicing. You get site-ready, quality-checked equipment every time.",
    icon: "🔧"
  },
  {
    title: "No Storage Worries",
    description: "Save valuable space and avoid storage costs. We pick up equipment when your project is complete.",
    icon: "📦"
  },
  {
    title: "Avoid Depreciation Losses",
    description: "Scaffolding depreciates quickly. Renting means you don't bear the cost of asset depreciation over time.",
    icon: "📉"
  },
  {
    title: "No Theft or Damage Risk",
    description: "Eliminate concerns about equipment theft, damage, or loss. We take care of the risks.",
    icon: "🛡️"
  },
  {
    title: "Flexibility for Any Project",
    description: "Scale up or down based on project needs. Access different types of scaffolding for different phases.",
    icon: "⚡"
  }
];
